import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import '../../../css/CustomerSupport/FAQ.css';
import Input from '../../Shared/Input';
import arrowup from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-up.svg';
import downarrow from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-down.svg';
import dropdownupcircle from '../../../Assets/CustomerSupport/Assets-WebApp/dropdown-up.svg';
import downarrowcircle from '../../../Assets/CustomerSupport/Assets-WebApp/dropdown.svg';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';

import { ApiCall } from '../../../Services/utils/ApiCall';
import { baseURL } from '../../../Services/config/apiGateway';
import { ALL_FAQ_CATEGORY_ENDPOINT, ALL_FAQ_QUESTIONS_ENDPOINT } from '../../../Services/config/apiEndPoints';

class FAQ extends Component {
    constructor(props) {
        super(props)
        this.container = React.createRef();
        this.state = {
            SelectCategory: '',
            categoryDropdown: false,
            isSubmit: false,
            CatagoryTemporary: '',
            isdropdown: [],
            answerdropStatus: [],
            allCategories: [],
            apiDataAvailable: true,
            apiQuestionsAvailable: false,
            Questionsdata: [],
            noResult: false
        }
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount = () => {
        document.addEventListener("mousedown", this.handleClickOutside);
        ApiCall(
            'GET',
            baseURL + ALL_FAQ_CATEGORY_ENDPOINT,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',

            },
        ).then((apiData) => {
            if (apiData.flag != -1) {
                if (apiData.flag == 500) {
                    this.setState({ apiDataAvailable: false });
                }
                else {
                    console.log('I am 200!');
                    apiData.sort(
                        (a, b) =>
                            a.categoryName.trim()[0].charCodeAt(0) -
                            b.categoryName.trim()[0].charCodeAt(0),
                    );

                    this.setState({ allCategories: apiData })
                }
            }
        });
    }

    handleClickOutside = event => {
        if (this.container.current && !this.container.current.contains(event.target)) {
            this.setState({ categoryDropdown: false });
        }
    };

    toggleDropdown = () => {
        this.setState({ categoryDropdown: !this.state.categoryDropdown });
    };

    changeCategory = (event) => {

        const found = this.state.allCategories?.find((name) => {
            if (name.categoryId === this.state.allCategories[event].categoryId) {
                return name
            }
        })
        this.setState({ SelectCategory: found.categoryName });
        this.setState({ categoryDropdown: !this.state.categoryDropdown });
        this.setState({ isSubmit: true });
        this.setState({ CatagoryTemporary: this.state.SelectCategory });
        this.setState({ answerdropStatus: [] });
        this.setState({ isdropdown: [] });

        //api call get
        if (this.state.allCategories[event]?.categoryName?.length > 0) {
            this.setState({ noResult: false });
            ApiCall(
                'GET',
                baseURL + ALL_FAQ_QUESTIONS_ENDPOINT + `?categoryId=${found.categoryName}`,
                {},
                {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',

                },
            ).then((apiData) => {
                if (apiData.flag != -1) {
                    if (apiData.flag == 500) {
                        this.setState({ apiQuestionsAvailable: false, noResult: true });

                    }
                    else {
                        console.log('I am 200!');


                        this.setState({ apiQuestionsAvailable: true });
                        this.setState({ Questionsdata: apiData })

                    }
                }
            });

        }
    }

    render() {
        let drop = this.state.categoryDropdown ? <img src={arrowup} /> : <img src={downarrow} />
        return (
            <div class="csoutercolorcontact">
                <MetaDecorator title={TitleDescription.FAQPageTitle} description={TitleDescription.FAQPageDescription} />
                <Header tilesFetched={() => { }} />
                <div class="csnofullcontact">
                    <div id="csnobox111contact">
                        <nav class="caacnononavbar">
                            <div className="caacnonavbarname">
                                <small id="nonavccontact"> FAQ</small>
                            </div>
                        </nav>
                        <hr class="hr1" />
                        <div class="notificationmaincardcontact">
                            <div class="toppartwhitecontact">
                                <div class="containsalldivcontact">
                                    <div className="pass-wrapper" id="caad07contact" >
                                        <Input
                                            readOnly class="form-control form-control-sm outline4"
                                            value={this.state.SelectCategory}
                                            placeholder="Select Category"
                                            type="text" id="caad066contact"
                                        />
                                        <i id="caainput_imgAddProfilecontact" onClick={this.toggleDropdown}>{drop}</i>
                                    </div>
                                    {this.state.apiDataAvailable &&
                                        this.state.categoryDropdown && (
                                            <div class="caaad08contact" >
                                                <div class="caadropdowncardcontact" ref={this.container} >
                                                    {(this.state.allCategories?.map((name, index) => {
                                                        return (
                                                            <table class='caaad09contact' key={index} onClick={() => this.changeCategory(index)} >
                                                                <td class="caatt1contact" >
                                                                    <small id="caatt2contact" >{name?.categoryName} </small>
                                                                </td>
                                                            </table>
                                                        );
                                                    }))}
                                                </div>
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                            {this.state.isSubmit ?
                                <div class="questionparttopdiv">
                                    <div class="questionheadingdiv">
                                        <small id="questionheading">Related Questions</small>
                                    </div>

                                    {this.state.apiQuestionsAvailable &&

                                        <div>

                                            <div class="containswhitequestionpart">
                                                {this.state.Questionsdata?.faqs?.map((questionandanswerdata, indexno) => {
                                                    return (
                                                        <div class="wholeinnerdivwhite">
                                                            <div class={this.state.isdropdown[indexno] ? "answerpartopen" : "questionwholediv"}>
                                                                <div class={this.state.isdropdown[indexno] ? "answerpartopeninside" : "containsquestionandimg"}>
                                                                    <div class="leftsidequestiondiv">
                                                                        <div class="leftsidequestioninnerdiv">
                                                                            <small id="questionsection">{questionandanswerdata?.question}</small>
                                                                        </div>
                                                                    </div>
                                                                    <div class="togglequestiondiv">
                                                                        <img
                                                                            src={this.state.answerdropStatus[indexno] ?
                                                                                dropdownupcircle :
                                                                                downarrowcircle
                                                                            }
                                                                            width="20"
                                                                            height="20"
                                                                            id="togglequestionimg"
                                                                            onClick={() => {
                                                                                let a = this.state.answerdropStatus;
                                                                                a[indexno] = !this.state.answerdropStatus[indexno];
                                                                                let b = this.state.isdropdown;
                                                                                b[indexno] = !this.state.isdropdown[indexno];
                                                                                this.setState({ answerdropStatus: a });
                                                                                this.setState({ isdropdown: b })
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {this.state.isdropdown[indexno] ?
                                                                <div class="answerpartdiv">
                                                                    <div class="inneranswerpart">
                                                                        <small id="answerpartinside">{questionandanswerdata?.answer}</small>
                                                                    </div>
                                                                </div>
                                                                :
                                                                null
                                                            }
                                                        </div>
                                                    );
                                                })}
                                            </div>

                                        </div>

                                    }

                                </div>
                                :
                                null
                            }
                            {this.state.isSubmit && this.state.noResult &&
                                <div class="newnotificationFAQ">
                                    <small id="nonotificationFAQ">No result found</small>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div class="notifooter01">
                    <Footer />
                </div>
                <div class="notifooter02">
                    <Footer2 />
                </div>
            </div>
        );
    }
}

export default FAQ;

